import { render, staticRenderFns } from "./RequestMgtResumeRequestButton.vue?vue&type=template&id=b72495e8&"
import script from "./RequestMgtResumeRequestButton.vue?vue&type=script&lang=js&"
export * from "./RequestMgtResumeRequestButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports